
































































import { Component, Vue, Prop } from 'vue-property-decorator'
import Tips from '@/components/Tips.vue'

export interface CreateBoccoChannelFormValue {
    name: string;
    description: string;
    file: File | undefined;
}

@Component({
    components: {
        Tips
    }
})
export default class CreateBoccoChannelForm extends Vue {
    @Prop({required: true})
    value: CreateBoccoChannelFormValue | undefined

    previewUrl: string | null = null
    tooLargeFile = false

    static valid(payload: CreateBoccoChannelFormValue) {
        const _validate = (target: string, min: number, max: number) => {
            if (min > target.length) return false
            if (target.length > max) return false
            return true
        }

        const result = 
            _validate(payload.name, 4, 20) && 
            _validate(payload.description, 4, 50)

        if (!result) {
            return false
        }

        if (payload.file) {
            if (payload.file.size > 256_000) return false
        }

        return true
    }

    get channelName() {
        return this.value!.name
    }

    set channelName(name: string) {
        const item = {...this.value!}
        item.name = name
        this.$emit("input", item)
    }

    get channelDescription() {
        return this.value!.description
    }

    set channelDescription(description: string) {
        const item = {...this.value!}
        item.description = description
        this.$emit("input", item)
    }

    get channelFile() {
        return this.value!.file
    }

    set channelFile(file: File | undefined) {
        if (file) {
            // check file
            if (file.size > (256 * 1024)) {
                this.tooLargeFile = true
                return
            }
            this.tooLargeFile = false
            this.previewUrl = window.URL.createObjectURL(file)
        } else {
            this.previewUrl = null
        }
        const item = {...this.value!}
        item.file = file
        this.$emit("input", item)
    }

    removeFile() {
        this.channelFile = undefined
    }
}
